import FAQSection, { FAQSectionProps } from './FAQSection'

export default FAQSection
export { FAQSection }
export type { FAQSectionProps }
